(function(){
  function init(){
    document.querySelectorAll('.spj-cp-estimator:not([data-ready])').forEach(function(root){
      root.dataset.ready='true';
      var form=root.querySelector('.spj-cp-form');
      var postal=form.querySelector('input');
      var result=root.querySelector('.spj-cp-result');
      var scope=root.closest('product-info')||document;
      var fast=root.dataset.fast==='true';
      var variants=[];
      try{variants=JSON.parse(root.dataset.variants||'[]')}catch(error){}
      function mexicoToday(){
        var arr=new Intl.DateTimeFormat('en-US',{timeZone:'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        var m={};arr.forEach(function(x){if(x.type!=='literal')m[x.type]=Number(x.value)});
        return new Date(Date.UTC(m.year,m.month-1,m.day,12));
      }
      function plusDays(date,days,working){
        var d=new Date(date.getTime());
        while(days>0){d.setUTCDate(d.getUTCDate()+1);if(!working||(d.getUTCDay()!==0&&d.getUTCDay()!==6))days--}
        return d;
      }
      function fmt(date){
        return new Intl.DateTimeFormat('es-MX',{timeZone:'UTC',day:'numeric',month:'short'}).format(date);
      }
      function calculate(){
        result.hidden=false;
        if(!/^\d{5}$/.test(postal.value.trim())){result.textContent='Escribe un código postal de 5 dígitos.';return}
        var input=scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        var variant=variants.find(function(v){return input&&String(v.id)===String(input.value)})||variants[0];
        var qtyInput=scope.querySelector('[id="Quantity-'+root.dataset.section+'"]');
        var qty=qtyInput?Math.max(1,parseInt(qtyInput.value,10)||1):1;
        var subtotal=(variant?Number(variant.price):0)*qty/100;
        var threshold=fast?1200:1000;
        var fee=fast?200:120;
        var shipping=subtotal>=threshold?'GRATIS':'$'+fee+' MXN';
        var date=mexicoToday();
        var eta=fast?fmt(plusDays(date,3,true))+'–'+fmt(plusDays(date,5,true)):fmt(plusDays(date,16,false));
        result.textContent=(fast?'Rápido':'Regular')+' · '+shipping+'\nEntrega aprox.: '+eta+'\nGratis desde $'+threshold.toLocaleString('es-MX')+' en esta modalidad.';
      }
      form.addEventListener('submit',function(e){e.preventDefault();calculate()});
      scope.addEventListener('change',function(e){
        if(!result.hidden && e.target!==postal && (e.target.matches('select,input[name="id"],input[name="quantity"]')||e.target.closest('variant-selects')))calculate();
      });
      scope.addEventListener('click',function(e){
        if(!result.hidden&&e.target.closest('.quantity__button'))requestAnimationFrame(calculate);
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();